import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { ScheduleData } from '../../hook/ScheduleData.js';
import ScheduleCardTeacher from '../ScheduleComponent/ScheduleCardTeacher.jsx';

function TeacherScheduleDetail() 
{
  const [filter, setFilter] = useState('spo');

  const { teacherName } = useParams();

  const spoData = ScheduleData('/Teacher', teacherName, false);
  const voData  = ScheduleData('/Teacher', teacherName, true);

  const loading = spoData.loading || voData.loading;
  const error   = spoData.error   || voData.error;

  if (loading) return <div className='loading'>Загрузка расписания...</div>;
  if (error)   return <div className='error'>Ошибка: {error}</div>;

  const combined = filter === 'vo'  ? voData.data
                 : filter === 'spo' ? spoData.data
                 : [...(voData.data || []), ...(spoData.data || [])];
  
  return (
     <div>
      <div className='edu-filter'>
        <button 
          className={`edu-filter__btn vo ${filter === 'vo' ? 'active' : ''}`}
          onClick={() => setFilter('vo')}
        >
          Высшее образование (ВО)
        </button>
        
        <button 
          className={`edu-filter__btn spo ${filter === 'spo' ? 'active' : ''}`}
          onClick={() => setFilter('spo')}
        >
          СПО
        </button>
      </div>
      <ScheduleCardTeacher scheduleData={combined} />
    </div>
  );
}

export default TeacherScheduleDetail;